<template>
  <div class="row">
    <div :class="{'col-md-10': !$store.state.printToPdfInProgress, 'col-md-12': $store.state.printToPdfInProgress}">
      <h4
        class="panel-title"
        v-show="$store.state.printToPdfInProgress"
      >
        <span :class="{'pdf-text': $store.state.printToPdfInProgress, 'area-heading': true}">{{ element.lang.title }}</span>
      </h4>
    </div>
    <div
      v-show="!$store.state.printToPdfInProgress"
      class="col-md-2 item_groups text-right"
    >
      <base-button
        additional-classes="item fa fa-pencil"
        color="link"
        title="Bereich bearbeiten"
        v-if="!$store.state.currentlyEditing.includes(element.id) && Object.keys(element.elements).length > 0"
        @click="startEditing()"
      />
      <base-button
        additional-classes="item fa fa-close"
        color="link"
        title="Bearbeitung abbrechen"
        v-if="$store.state.currentlyEditing.includes(element.id)"
        @click="stopEditing()"
      />
      <base-button
        additional-classes="item fa fa-trash"
        color="link"
        title="Bereich löschen"
        @click="deleteElement()"
      />
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/BaseButton.vue';

/**
 * Die Darstellungskomponente für ein Area Element
 * @displayName AppElementsAreaHeading
 */
export default {
  name: 'AppElementsAreaHeading',
  components: {BaseButton},
  props: {
    element: {
      type: Object,
      required: true
    }
  },
  emits: ['delete:self'],
  computed: {
    settings() {
      let array = [];

      Object.keys(this.element.elements).forEach(key => {
        let setting = this.element.elements[key];

        if (typeof setting.settings !== 'undefined' && setting.settings.preview) {
          array.push(key)
        }
      })

      return array
    }
  },
  methods: {
    stopEditing() {
      this.$store.commit('triggerSaveAll');
      this.$store.commit('stopEditing', this.element.id);
    },
    startEditing() {
      this.$store.commit('startEditing', this.element.id);
    },
    deleteElement(){
      this.$emit('delete:self', this.element.id);
    },
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
  }
}
</script>

<style lang="less">

.ed_panel .panel-heading.ed_panel_heading_actionbar {
  @media (max-width: 991px) {
    margin-top: -5px;

    .item-group {
      .item {
        color: #000;
        border-left: none !important;
      }
    }

    .panel-title {
      line-height: 0;
    }
  }
}

.area-heading {
  @media (max-width: 991px) {
    display: none;
  }
}

.panel-title {
}

.btn,
.btn-link {
  &:hover,
  &:focus,
  &:active,
  &:active:focus {
    text-decoration: none;
    outline: none;
  }
}

.item {
  border-radius: unset;
  height: 40px;
  min-width: 40px;

  &:hover {
    background-color: #e2f0ef; // mint
  }

  &--active,
  &--active .btn {
    color: #fff;
    background-color: #0375a6; // primary
    top: 0;
  }

  &--active:hover,
  &--active:hover .btn {
    cursor: pointer;
    color: #fff;
    background-color: #349691; // mint-light
  }

  &--disabled {
    color: #fff;
    background-color: #c9c9c9;

    &:hover,
    &:focus,
    &:active,
    &:active:focus {
      color: #fff;
      background-color: lighten(#c9c9c9, 2%);
    }
  }
}
</style>